<script setup lang="ts">
import findSm from "~/assets/icons/find/find-sm.svg"

const { searchButton } = useGlobals()
const { openInstantSearch } = useInstantSearch()
</script>

<template>
  <nav-pill-button
    inner
    class="search-pill-button"
    :class="[searchButton]"
    @click="openInstantSearch()"
  >
    <findSm class="w-4.5 h-4.5" />
  </nav-pill-button>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.search-pill-button
  @apply h-6 w-6 flex items-center justify-center p-0
</style>
